import React, { useState } from "react";
import "../../../../../styles/shared/add-balance.css";

// components imports
import Loader from "../../../../../Components/CircularLoader/CircularLoader";

// apis imports
// import { createNewDriver } from "../../../../../services/drivers.services";
import { updateBalance } from "../../../../../services/AdminServices/PaymentsAdmin/payments.services";

// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

const initialData = {
  balance: "",
  notes: "",
  payment_type: "by_hand",
};

export default function AddBalance({ open, setOpen, setSnack, setPayments }) {
  const { t } = useTranslation("admin");
  const user = useSelector((state) => state.user);

  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setData(initialData);
    setOpen(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const handleFieldChange = (name, value) => {
    setData({ ...data, [name]: value });
  };

  const handleSave = async () => {
    setLoading(true);

    // const saved = await createNewDriver(user.token, data);
    const id = open.id;
    const response = await updateBalance(data, id);
    if (response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("payments.balanceUpdatedSuccessfully"),
          severity: "success",
        };
      });
    }
    setPayments((prevPayments) => {
      return {
        ...prevPayments,
        data: prevPayments?.data.map((shipper) => {
          return shipper.id === id ? response?.data?.result : shipper;
        }),
      };
    });
    setData(initialData);
    setLoading(false);
    handleClose();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="admnadd__balance_modal">
          <div className="admnadd__balance_modalheading">{t("payments.addBalance")}</div>
          <div className="admnadd__balance_modalcontent">
            <div className="admnedit__user_modalrow">
              <div className="admnedit__user_modalinputwrap">
                <label className="admnadd__balance_modallbl">
                  {t("payments.paymentType")}
                </label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  initialValue="by_hand"
                  options={["by_hand", "bank_transfer", "cheque"]}
                  getOptionLabel={(option) => option}
                  sx={{
                    "&  div": {
                      outline: "none",
                      padding: 0,
                      border: "none",
                      outline: "none",
                      height: "50px",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("payments.paymentType")}
                      className="admnedit__user_modalinput"
                      sx={{
                        height: "50px",
                        "&  div": {
                          height: "50px",
                        },
                      }}
                    />
                  )}
                  value={data.payment_type}
                  onChange={(e, payment_type) =>
                    handleFieldChange("payment_type", payment_type)
                  }
                />
              </div>
            </div>
            <div className="admnadd__balance_modalrow">
              <div className="admnadd__balance_modalinputwrap">
                <label className="admnadd__balance_modallbl">{t("payments.amount")}</label>
                <input
                  className="admnadd__balance_modalinput"
                  placeholder={t("payments.enterAmount")}
                  name="balance"
                  value={data.balance}
                  onChange={handleChange}
                  type="number"
                />
              </div>
            </div>
            <div className="admnadd__balance_modalrow">
              <div className="admnadd__balance_modalinputwrap">
                <label className="admnadd__balance_modallbl">
                  {t("payments.instructions")}
                </label>
                <input
                  className="admnadd__balance_modalinput"
                  placeholder={t("payments.enterInstructions")}
                  name="notes"
                  value={data.notes}
                  onChange={handleChange}
                  type="text"
                />
              </div>
            </div>
          </div>
          <div className="admnadd__balance_modalfooter">
            <div className="admnadd__balance_modalcncl" onClick={handleClose}>
              {t("common:actions.cancel")}
            </div>
            <div className="admnadd__balance_modalsave" onClick={handleSave}>
              {loading ? <Loader /> : t("common:actions.save")}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
